module.exports = __webpack_public_path__ + "img/pv-chat.9ab1676b.svg";